// extracted by mini-css-extract-plugin
export var ctasSection = "G_b4";
export var defaultBackground = "G_b9";
export var heroBackground = "G_b2";
export var heroContainer = "G_b3";
export var heroHeadline = "G_b7";
export var imageSection = "G_b5";
export var subTitleSection = "G_b8";
export var textSection = "G_b6";